module.exports = __webpack_public_path__ + "static/media/icon_sac.20cd0b4e.svg";